module.exports = __webpack_public_path__ + "img/car.916df163.svg";